import { useEffect, useState } from "react";
import axios from "axios";
import { Authorization } from "../../../Context/Authorization";
import { toast } from "react-toastify";

const inputStyle = {
  width: "100%", padding: "9px 12px", border: "1.5px solid #E2E8F0",
  borderRadius: 8, fontSize: 13, color: "#1A202C", background: "#fff",
  outline: "none", transition: "border-color 0.2s",
};
const labelStyle = { fontSize: 12, fontWeight: 600, color: "#2D3748", marginBottom: 6, display: "block" };

const EditLoanRepayment = ({ show, onHide, repaymentId, onUpdated }) => {
  const [loading, setLoading] = useState(true);
  const [form, setForm] = useState({
    amountPaid: 0, interestPaid: 0,
    cashOrBank: "", paymentDate: "",
  });
  const Api = process.env.REACT_APP_API;

  useEffect(() => {
    if (!show || !repaymentId) return;

    setLoading(true);

    const fetchData = async () => {
      try {
        const config = Authorization();

        const { data } = await axios.get(
          `${Api}/api/loan-collections/${repaymentId}`,
          config
        );

        const repayment = data.loanCollection;

        setForm({
          amountPaid: repayment.amountPaid || 0,
          interestPaid: repayment.interestPaid || 0,
          cashOrBank: repayment.cashOrBank || "",
          paymentDate: repayment.paymentDate
            ? repayment.paymentDate.slice(0, 10)
            : "",
        });
      } catch (err) {
        console.error("Error loading repayment:", err);
        toast.error("Failed to load repayment details.");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [show, repaymentId, Api]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    try {
      const config = Authorization();

      await axios.put(
        `${Api}/api/loan-collections/${repaymentId}`,
        {
          amountPaid: Number(form.amountPaid),
          interestPaid: Number(form.interestPaid),
          cashOrBank: form.cashOrBank,
          paymentDate: form.paymentDate,
        },
        config
      );

      toast.success("Repayment updated successfully.");

      onUpdated?.();
      onHide();
    } catch (err) {
      console.error(err);
      toast.error(
        err.response?.data?.message || "Failed to update repayment."
      );
    }
  };

  if (!show) return null;

  if (loading) {
    return (
      <div
        style={{
          position: "fixed",
          inset: 0,
          background: "rgba(0,0,0,.5)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 1050,
        }}
      >
        <div
          style={{
            background: "#fff",
            padding: 30,
            borderRadius: 10,
          }}
        >
          Loading...
        </div>
      </div>
    );
  }

  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1050 }}>
      <div style={{ background: "#fff", borderRadius: 12, width: 520, maxWidth: "95vw", boxShadow: "0 8px 32px rgba(0,0,0,0.18)", overflow: "hidden" }}>

        {/* Modal Header */}
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "16px 20px", background: "linear-gradient(135deg,#1B5E20,#2E7D32)" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <span style={{ width: 30, height: 30, background: "rgba(255,255,255,0.15)", borderRadius: 8, display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontSize: 15 }}>
              <i className="mdi mdi-cash-refund" />
            </span>
            <span style={{ fontSize: 14, fontWeight: 700, color: "#fff" }}>Edit Loan Repayment</span>
          </div>
          <button onClick={onHide} style={{ background: "none", border: "none", color: "#fff", fontSize: 18, cursor: "pointer", lineHeight: 1 }}>
            <i className="mdi mdi-close" />
          </button>
        </div>

        {/* Modal Body */}
        <div style={{ padding: "20px 24px" }}>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 }}>
            <div>
              <label style={labelStyle}>Amount Paid</label>
              <input type="number" name="amountPaid" value={form.amountPaid} onChange={handleChange} min={0} style={inputStyle}
                onFocus={(e) => (e.target.style.borderColor = "#4CAF50")} onBlur={(e) => (e.target.style.borderColor = "#E2E8F0")} />
            </div>
            <div>
              <label style={labelStyle}>Interest Paid</label>
              <input type="number" name="interestPaid" value={form.interestPaid} onChange={handleChange} min={0} style={inputStyle}
                onFocus={(e) => (e.target.style.borderColor = "#4CAF50")} onBlur={(e) => (e.target.style.borderColor = "#E2E8F0")} />
            </div>
            <div>
              <label style={labelStyle}>Payment Mode</label>
              <select name="cashOrBank" value={form.cashOrBank} onChange={handleChange} style={inputStyle}
                onFocus={(e) => (e.target.style.borderColor = "#4CAF50")} onBlur={(e) => (e.target.style.borderColor = "#E2E8F0")}>
                <option value="">Select</option>
                <option value="cash">Cash</option>
                <option value="bank">Bank</option>
              </select>
            </div>
            <div>
              <label style={labelStyle}>Payment Date</label>
              <input type="date" name="paymentDate" value={form.paymentDate} onChange={handleChange} style={inputStyle}
                onFocus={(e) => (e.target.style.borderColor = "#4CAF50")} onBlur={(e) => (e.target.style.borderColor = "#E2E8F0")} />
            </div>
          </div>
        </div>

        {/* Modal Footer */}
        <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, padding: "14px 24px", borderTop: "1px solid #EDF2F7" }}>
          <button onClick={onHide}
            style={{ padding: "9px 20px", background: "#fff", border: "1.5px solid #E2E8F0", borderRadius: 8, fontSize: 13, fontWeight: 600, color: "#4A5568", cursor: "pointer" }}>
            Cancel
          </button>
          <button onClick={handleSubmit}
            style={{ padding: "9px 20px", background: "linear-gradient(135deg,#1B5E20,#2E7D32)", border: "none", borderRadius: 8, fontSize: 13, fontWeight: 700, color: "#fff", cursor: "pointer", boxShadow: "0 3px 10px rgba(46,125,50,0.3)" }}>
            Save Changes
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditLoanRepayment;
